import {
  AccordionDetails,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  Box,
} from "@mui/material";
import React, { useRef } from "react";
import { useStyles } from "../styles";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import useStaff from "../../../../Hooks/staff";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import RemoveIcon from "@mui/icons-material/Remove";
import { useLocation } from "react-router-dom";

export const addStaffCertificationInfromationSchema = Yup.object().shape({
  certificationName: Yup.string().required(
    "*Please enter the certification Name"
  ),
  certifiedYear: Yup.string().required(
    "*Please enter the completion certfication year"
  ),
  certificationBody: Yup.string().required(
    "*Please enter the certification body"
  ),
  aggregate: Yup.string().required("*Please enter the aggregate"),
});

const AddCertificationInformation = (props) => {
  const { currentIndex, staffCertificationRef } = props;
  const classes = useStyles();
  const [edit, setEdit] = React.useState("");
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname === "/staffManagement/editStaff") {
      setEdit(true);
    } else {
      setEdit(false);
    }
  }, [location]);

  const {
    addStaffCertificationInfo,
    removeCertificationAction,
    staffPersonalInfo,
    addNewCertification,
    updateCertificationInfoItemDataAction,
    deleteCertifyAction,
  } = useStaff();

  React.useEffect(() => {
    if (staffCertificationRef.current) {
      const { setFieldValue } = staffCertificationRef.current;
      setFieldValue(
        "id",
        addNewCertification && addNewCertification[currentIndex]?.id
      );
      setFieldValue(
        "idFaculty",
        addNewCertification &&
          addNewCertification[currentIndex]?.idFaculty != undefined
          ? addNewCertification[currentIndex]?.idFaculty
          : staffPersonalInfo && staffPersonalInfo?.id
      );
    }
  }, [addNewCertification, staffPersonalInfo]);

  React.useEffect(() => {
    if (staffCertificationRef.current) {
      const { setFieldValue } = staffCertificationRef.current;
      if (edit) {
        setFieldValue(
          "certificationName",
          (addNewCertification &&
            addNewCertification[currentIndex]?.certificationName) ||
            ""
        );
        setFieldValue(
          "certifiedYear",
          (addNewCertification &&
            addNewCertification[currentIndex]?.certifiedYear) ||
            ""
        );
        setFieldValue(
          "certificationBody",
          (addNewCertification &&
            addNewCertification[currentIndex]?.certificationBody) ||
            ""
        );
        setFieldValue(
          "aggregate",
          (addNewCertification &&
            addNewCertification[currentIndex]?.aggregate) ||
            ""
        );
      }
    }
  }, [edit, addNewCertification]);

  const addStaffCertification = {
    certificationName: "",
    certifiedYear: "",
    certificationBody: "",
    aggregate: "",
    idFaculty: "",
    id: "",
  };

  return (
    <Stack>
      <Stack sx={{ color: "#25D5A1" }}>
        <Stack
          sx={{
            width: "80px",
            height: "80px",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            borderRadius: "50px",
          }}
          onClick={() => {
            removeCertificationAction({ key: currentIndex });
            deleteCertifyAction({ id: addNewCertification[currentIndex]?.id });
          }}
        >
          <RemoveIcon />
        </Stack>
      </Stack>
      <Formik
        validationSchema={addStaffCertificationInfromationSchema}
        initialValues={addStaffCertification}
        validateOnBlur={false}
        validateOnChange={false}
        innerRef={staffCertificationRef}
        onSubmit={(values) => {
          //  addStaffCertificationInfo({...values})
        }}
      >
        {(fromik) => {
          const {
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            values,
          } = fromik;
          return (
            <form id="addStaffCertification" onSubmit={handleSubmit}>
              <AccordionDetails>
                <Grid container spacing={6}>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="certificationName"
                          name="certificationName"
                          placeholder="Certification name"
                          IconComponent={CustomExpandMore}
                          defaultValue=""
                          displayEmpty
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.certificationName &&
                            touched.certificationName
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateCertificationInfoItemDataAction({
                              type: "certificationName",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.certificationName}
                        >
                          {/* <MenuItem value="" disabled>
                            Certification Name
                          </MenuItem>
                          <MenuItem value="PG">PG</MenuItem>
                          <MenuItem value="UG">UG</MenuItem>
                          <MenuItem value="M.Ed">M.Ed</MenuItem>
                          <MenuItem value="M.PhiL">M.Phil</MenuItem> */}
                        </TextField>
                      </Stack>
                      <ErrorMessage
                        name="certificationName"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="certifiedYear"
                          name="certifiedYear"
                          type="number"
                          placeholder="Year"
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.certifiedYear && touched.certifiedYear
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateCertificationInfoItemDataAction({
                              type: "certifiedYear",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.certifiedYear}
                        />
                      </Stack>
                      <ErrorMessage
                        name="certifiedYear"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                  </Grid>
                  <Grid item md={4} sm={12}>
                    <Box
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 4,
                        mb: 2,
                      }}
                    >
                      <Stack>
                        <TextField
                          id="certificationBody"
                          name="certificationBody"
                          placeholder="Certification body"
                          IconComponent={CustomExpandMore}
                          defaultValue=""
                          displayEmpty
                          sx={{
                            width: "200px",
                          }}
                          className={
                            errors.certificationBody &&
                            touched.certificationBody
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          onBlur={handleBlur}
                          onChange={(e) => {
                            handleChange(e);
                            updateCertificationInfoItemDataAction({
                              type: "certificationBody",
                              index: currentIndex,
                              data: e.target.value,
                            });
                          }}
                          value={values.certificationBody}
                        >
                          {/* <MenuItem value="" disabled>
                            Certification Body
                          </MenuItem>
                          <MenuItem value="Passed">Passed</MenuItem>
                          <MenuItem value="Fail">Fail</MenuItem>
                          <MenuItem value="Pursuing">Pursuing</MenuItem> */}
                        </TextField>
                      </Stack>
                      <ErrorMessage
                        name="certificationBody"
                        component="span"
                        className={classes.error}
                      />
                    </Box>
                    <Stack>
                      <TextField
                        id="aggregate"
                        name="aggregate"
                        placeholder="Aggregate"
                        type="number"
                        sx={{
                          width: "200px",
                        }}
                        className={
                          errors.aggregate && touched.aggregate
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        InputProps={{ inputProps: { min: 1, max: 100 } }}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          handleChange(e);
                          updateCertificationInfoItemDataAction({
                            type: "aggregate",
                            index: currentIndex,
                            data: e.target.value,
                          });
                        }}
                        value={values.aggregate}
                      />
                      <ErrorMessage
                        name="aggregate"
                        component="span"
                        className={classes.error}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </form>
          );
        }}
      </Formik>
    </Stack>
  );
};

export default AddCertificationInformation;
